import React, { useCallback } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import ReactGA from 'react-ga4';

import CustomPagination from "../../../uiKit/CustomTable/pagination";
import ProgressBar from "../../../uiKit/ProgressBar/ProgressBar";
import CustomMobilePagination from "../../../uiKit/CustomTable/mobilePagination";
import Title from "../../../uiKit/Title/Title";
import { blue500, gray900 } from "../../../uiKit/assets/colors/colors";
import NoCampaigns from "./noCampaigns";
import Badge from "../Campaign/ActiveCampaign/campaignBadge";

const CampaignsDesktopList = ({
    data = [],
    tableUrl = '/',
    type = 'active',
}) => {
    const { communityId } = useParams();
    const screenWidth = useSelector(state => state.common.screenWidth, shallowEqual);
    const userId = useSelector(state => state.account.userDetails?.id, shallowEqual);

    return (
        !!data.items && !!data.items.length ? (
            <>
                <div className='campaignsListWrapper'>
                    {data.items.map((campaign, index) => <CampaingCard key={index} campaign={campaign} />)}
                </div>
                {
                    screenWidth > 767 ? <CustomPagination
                        data={data}
                        tableUrl={tableUrl}
                        pageSize={9}
                        scrollToY={!!userId && !communityId ? 0 : 500}
                        style={{
                            borderRadius: '4px',
                            marginTop: '20px',
                        }}
                    /> : <CustomMobilePagination
                        data={data}
                        tableUrl={tableUrl}
                        style={{
                            borderRadius: '4px',
                            marginTop: '20px',
                        }}
                    />
                }
            </>
        ) : (
            <div className='campaignsListWrapper'>
                {!!userId && <NoCampaigns title={type} />}
            </div>
        )
    )
}

const CampaingCard = ({ campaign }) => {
    const history = useHistory();
    const { communityId } = useParams();
    const campaignType = campaign.status === 'launched' ? 'active' : 'completed';

    const onCampaignClick = useCallback(() => {
        const { id, communityId } = campaign;
        ReactGA.event(`${campaignType}_campaign_click`)

        const userId = window.localStorage.getItem("userId");
        if (!!userId) {
            history.push(`/campaigns/campaign/${campaignType}/${communityId}/${id}`)
            return;
        }

        history.push({
            pathname: `/`,
            search: `?pageType=campaign&communityId=${communityId}&campaignId=${id}`
        });
        window.scrollTo(0, 0);
    }, [history, campaign, campaignType])

    const onCommunityClick = useCallback((event) => {
        event.stopPropagation();
        const { communityId } = campaign;
        ReactGA.event(`${campaignType}_campaign_click`)
        history.push(`/communities/community/${communityId}`)
    }, [history, campaign, campaignType])

    return (
        <div className="campaignWrapper" onClick={onCampaignClick} >
            <div style={{ position: 'relative' }}>
                <img src={campaign.images.desktop} className="photoWrapperCampaign" alt="" style={{ height: '147px' }} />
                <Badge campaignUrgencyType={campaign.campaignUrgencyType} />
            </div>
            <Title text={campaign.name} fontSize={16} />
            <Title
                text={campaign.communityName}
                fontSize={12}
                lineHeight={14}
                fontWeight={400}
                color={!!communityId ? blue500 : gray900}
                onClick={!!communityId ? onCommunityClick : null}
            />
            <ProgressBar
                campaignId={campaign.id}
                communityId={campaign.communityId}
                target={campaign.amount}
                isActive={campaign.status === 'launched'}
                className=""
            />
        </div>
    )
}

export default CampaignsDesktopList;